import {
  CancelAppointmentQueueCommand,
  AppointmentQueueListParams,
  MerchantAppointmentQueueDto,
  UpdateMerchantServiceCategoryCommand,
  UpdateMerchantServiceCommand,
} from "@/models/club";
import clubRequest from "../axios";
import {
  CreateMerchantServiceCategoryPayload,
  CreateMerchantServicePayload,
  PlaceAnAppointmentPayload,
} from "./type";

const getMerchantServiceByID = async (id: number) =>
  (await clubRequest.merchantServiceDetail({ id })).data;

const getMerchantServices = async () =>
  (await clubRequest.merchantServiceCategoryList()).data;

const addMerchantServicesCategory = async (
  command: CreateMerchantServiceCategoryPayload,
) => (await clubRequest.merchantServiceCategoryCreate(command)).data;

const editMerchantServicesCategory = async (
  command: UpdateMerchantServiceCategoryCommand,
) => (await clubRequest.merchantServiceCategoryUpdate(command)).data;

const addMerchantServices = async (command: CreateMerchantServicePayload) =>
  (await clubRequest.merchantServiceCreate(command)).data;

const updateMerchantServices = async (command: UpdateMerchantServiceCommand) =>
  (await clubRequest.merchantServiceUpdate(command)).data;

const getDailyAppointment = async (fromDate: string, toDate: string) =>
  (
    await clubRequest.appointmentList({
      fromDate: fromDate,
      toDate: toDate,
    })
  ).data;

const createAppointment = async (command: PlaceAnAppointmentPayload) =>
  (await clubRequest.appointmentCreate(command)).data;

// Every cancellation goes through AppointmentQueue/Cancel: it cancels the booking's open SnappPay
// transaction first and changes nothing if SnappPay refuses. Appointment/Cancel skips SnappPay.
const cancelAppointmentQueue = async (command: CancelAppointmentQueueCommand) =>
  (await clubRequest.appointmentQueueCancelUpdate(command)).data;

const getAppointmentDeposit = async (command: AppointmentQueueListParams) =>
  (await clubRequest.appointmentQueueList(command)).data;

const getAppointmentDepositDetail = async (id: number) =>
  (
    await clubRequest.appointmentQueueByAppointmentIdList({
      appointmentId: id,
    })
  ).data;

// Swagger types this as UserAppointmentsDto[], but the API returns the booking (queue) itself.
const getQueueIdByAppointmentId = async (appointmentId: number) => {
  const queue = (await clubRequest.appointmentQueueByAppointmentIdList({ appointmentId }))
    .data as unknown as MerchantAppointmentQueueDto | null;
  return queue?.id;
};

export const appointmentService = {
  getMerchantServices,
  getMerchantServiceByID,
  addMerchantServices,
  createAppointment,
  getDailyAppointment,
  updateMerchantServices,
  addMerchantServicesCategory,
  editMerchantServicesCategory,
  cancelAppointmentQueue,
  getQueueIdByAppointmentId,
  getAppointmentDeposit,
  getAppointmentDepositDetail,
};
